<template>
    <div>
        <!--<loader :active="loading"></loader>-->

        <div v-if="!loading">
            <div v-if="resultado_simulacao.parcelas.length > 0">
                <table class="bordered highlight">
                    <thead>
                    <tr>

                        <th v-show="!$hasRole('promotor')">Data</th>
                        <th v-show="!$hasRole('promotor')">Tipo</th>
                        <th>#</th>
                        <th>Total</th>
                        <th>Principal</th>
                        <th>Juros</th>
                        <th v-show="!$hasRole('promotor')">Comissão</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-show="!$hasRole('promotor')">
                        <td>{{ data_desembolso }}</td>
                        <td>Desembolso</td>
                        <td>1</td>
                        <td>{{ resultado_simulacao.total_emprestimo | currency('R$', 2, ',', '.') }}</td>
                        <td>{{ resultado_simulacao.total_emprestimo | currency('R$', 2, ',', '.') }}</td>
                        <td>{{ 0 | currency('R$', 2, ',', '.') }}</td>
                        <td>{{ 0 | currency('R$', 2, ',', '.') }}</td>
                    </tr>
                    <tr v-for="(parcela, k) in resultado_simulacao.parcelas" v-show="!$hasRole('promotor') || k != 0">
                        <td v-show="!$hasRole('promotor')">{{ dataFormatada(parcela.data) }}</td>
                        <td v-show="!$hasRole('promotor')">Parcela</td>
                        <td>{{ k }}</td>
                        <td>{{ parcela.comissao || (parcela.principal + parcela.interest) | currency('R$', 2, ',', '.')
                            }}
                        </td>
                        <td>{{ parcela.principal | currency('R$', 2, ',', '.') }}</td>
                        <td>{{ parcela.interest | currency('R$', 2, ',', '.') }}</td>
                        <td v-show="!$hasRole('promotor')">{{ parcela.comissao | currency('R$', 2, ',', '.') }}</td>
                    </tr>
                    </tbody>
                </table>
                <p>Total: {{ resultado_simulacao.total | currency('R$', 2, ',', '.') }}</p>
                <p>Total empréstimo: {{ resultado_simulacao.total_emprestimo | currency('R$', 2, ',', '.') }}</p>
                <p>Total líquido : {{ resultado_simulacao.total_liquido | currency('R$', 2, ',', '.') }}</p>
                <p>Total juros: {{ resultado_simulacao.total_juros | currency('R$', 2, ',', '.') }}</p>
                <p>Total taxas: {{ resultado_simulacao.total_taxas | currency('R$', 2, ',', '.') }}</p>
                <p>Juros mensal: {{ resultado_simulacao.juros_mensal }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from './utils/InlineLoader.vue'

    export default {
        props: [
            'resultado_simulacao',
            'data_desembolso',
            'loading'
        ],
        methods: {
            dataFormatada(data) {
                return moment(data).format('DD/MM/Y');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SimulacaoParcelasResultado.vue